<template>
  <div id="app">
    <top-header />
    <login-form
      v-if="showLogin"
      @login="login"
      @closeLogin="closeLogin"
      :error="error"
    />
    <error-popup
      v-if="error && !showLogin"
      :errorMessage="errorMessage"
      :defaultMessage="defaultMessage"
      @hide="hide"
      :black="black"
    />
    <read-more v-if="visible" />
    <more-info v-if="display" :type="type" />
    <add-base-ref-popup
      v-if="Object.keys(item).length > 0"
      :location="location"
      :item="item"
      @addToGroup="addToGroup"
      @closePopup="closeAddBaseRefPopup"
    />
    <leave-popup v-if="pathTo.length > 0" :to="pathTo" @close="close()" />
    <modal-mask
      v-if="popupIsOpen"
      @closePopup="closePopup()"
      :popupDark="popupDark"
    />
    <transition name="slide-fade">
      <popup-left
        v-if="popupIsOpen"
        @closePopup="closePopup()"
        :popupType="popupType"
        :popupDark="popupDark"
        :popupContent="popupContent"
      />
    </transition>
    <router-view />
    <bottom-footer />
  </div>
</template>

<script>
import TopHeader from "@/components/TopHeader.vue";
import LoginForm from "@/components/LoginFlow/PopupLogin.vue";
import ErrorPopup from "@/components/ErrorPopup.vue";
import ReadMore from "@/components/ReadMore.vue";
import AddBaseRefPopup from "@/components/AddBaseRefPopup.vue";
import MoreInfo from "@/components/MoreInfo.vue";
import LeavePopup from "@/components/LeavePopup.vue";
import ModalMask from "@/components/Modal-mask.vue";
import PopupLeft from "@/components/PopupLeft/PopupLeft.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import router from "@/router";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "app",
  components: {
    TopHeader,
    LoginForm,
    ErrorPopup,
    ReadMore,
    AddBaseRefPopup,
    MoreInfo,
    LeavePopup,
    ModalMask,
    PopupLeft,
    BottomFooter,
  },
  data() {
    return {
      black: false,
      error: false,
      errorMessage: "",
      defaultMessage: "",
    };
  },
  created: function () {
    const token = localStorage.getItem("token");
    if (token) {
      this.$store.commit("auth/setToken", token);
      this.getUserDB();
    }
  },
  watch: {
    $route: function (params) {
      this.defaultMessage = "Oh no!";
      if (params.query.error === 400) {
        this.error = true;
        this.errorMessage =
          "Er ging iets mis bij het invoeren, probeer nog eens";
      } else if (params.query.error === 401) {
        this.error = true;
        this.errorMessage = "Uw sessie is verlopen, log opnieuw in";
        this.logout();
        this.$router.push("/");
      } else if (params.query.error === 404) {
        this.error = true;
        this.errorMessage = "Er ging iets mis met de query";
      } else if (params.query.error === 500) {
        this.error = true;
        this.errorMessage = "Er ging iets mis met de connectie van de database";
      }
    },
  },
  methods: {
    hide() {
      this.error = false;
      router.push({ query: {} });
    },
    ...mapMutations("popupLeft", ["closePopup"]),
    ...mapMutations("leavePopup", ["close"]),
    ...mapMutations("addBaseRefPopup", ["closeAddBaseRefPopup"]),
    ...mapMutations("baseRef", ["addToGroup"]),
    ...mapMutations("auth", ["closeLogin"]),
    ...mapActions("auth", ["login", "logout", "getUserDB"]),
  },
  computed: {
    ...mapState("popupLeft", [
      "popupIsOpen",
      "popupType",
      "popupDark",
      "popupContent",
    ]),
    ...mapState("auth", ["showLogin", "user"]),
    ...mapState("readMore", ["visible"]),
    ...mapState("moreInfo", ["display", "type"]),
    ...mapState("leavePopup", ["pathTo"]),
    ...mapState("addBaseRefPopup", ["location", "item"]),
  },
};
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i')
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i')
.slide-fade-enter-active
  transition: all .3s ease
.slide-fade-leave-active
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)
.slide-fade-enter, .slide-fade-leave-to
  transform: translateX(-100%)
html
  scroll-behavior: smooth
body
  margin: 0
  height: 100%
.paddings
  padding-left: 25px
  padding-right: 25px
.full-height
  min-height: calc(100vh - 140px)
  max-width: 1660px
  width: 100%
  box-sizing: border-box
  margin: 0 auto
  color: $black
button, .btn, .btn-1, .btn2, .btn-grey, .btn-submit, .btn-header, .dropbtn, .btn-hide, .btn-save, .btn-noSave, .res-button, .btn-next, .btn-previous
  font-family: "Ubuntu"
  &:hover
    cursor: pointer
  &:focus
    outline: none
.highlight
  font-weight: 600
#app
  font-family: 'Ubuntu', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  display: flex
  flex-direction: column
  color: $white
  position: relative
  overflow: hidden
.errorBox
  z-index: 10000
  position: fixed
  top: 70px
  right: 20px
  display: flex
  background-color: $white
  height: 80px
  width: 440px
  border-left: 5px solid $red
  box-shadow: 2px 2px 10px 0 rgba(33,42,50,0.3)
  border-radius: 5px
  color: $black
  box-sizing: border-box
  padding: 14px 10px 14px 21px
  .box
    display: flex
    width: 100%
    height: 100%
    position: relative
    align-items: center
    .wrapper
      display: flex
      .error
        margin: 0
        font-size: 15px
        line-height: 26px
        margin-right: 55px
  .close
    position: absolute
    right: 0
    height: 34px
    width: 34px
    &:hover
      cursor: pointer
  &.black
    background-color: $grey
    color: $white

@media only screen and (min-width: 1200px)
  .paddings
    padding-left: 75px
    padding-right: 75px
</style>
